import React, { PureComponent } from 'react';

class FullScreenMobileControl extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showClickableLayer: true
    };
    this.onFullscreenControlClick = this.onFullscreenControlClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isFakeFullscreenOpen === this.state.showClickableLayer) {
      this.setState({ showClickableLayer: !this.state.showClickableLayer });
    }
  }

  onFullscreenControlClick(e) {
    e.persist();
    this.setState({
      showClickableLayer: false
    }, () => {
      const root = document.documentElement;
      const currentY = (window.pageYOffset || root.scrollTop) - (root.clientTop || 0);
      const elem = document.elementFromPoint(e.nativeEvent.clientX, e.nativeEvent.clientY);
      if (elem.nodeName !== 'svg') {
        elem.click();
      }
      window.setTimeout(() => this.props.onOpenFakeFullscreenClick(currentY), 110);
    });
  }

  render() {
    return (
      !this.props.isFakeFullscreenOpen && this.state.showClickableLayer ?
        <div
          className="fullscreen-mobctrl-disabled fullscreen-mobctrl desk-hide"
          onClick={this.onFullscreenControlClick}
        >
        </div>
      : null
    );
  }

}

export default FullScreenMobileControl;



/** WEBPACK FOOTER **
 ** ./core_components/FullScreen/FullScreenMobileControl.js
 **/